export default __webpack_public_path__ + "static/1-50a6c45d0b3d7921fc8319f3c6c645e0.jpeg";